import {getPointField} from "../../../helpers/sqftHelper";

export default class RenderFreeForm {

  /**
   * Renders a closed shape by connecting an array of points on the canvas.
   * Assumes points is an array of objects with x and y properties.
   * @param {CanvasRenderingContext2D} ctx - The canvas rendering context.
   * @param {Array<{x: number, y: number}>} points - Array of points to connect.
   */
  static renderShapeBetweenPoints = (ctx, points) => {
    if (points.length < 2) {
      //console.error('Need at least three points to render a shape.');
      return; // Need at least three points to form a closed shape
    }
    let pointField = getPointField(points[0].x, points[0].y);
    ctx.beginPath(); // Start a new path
    ctx.moveTo(pointField.x, pointField.y); // Move to the first point

    // Loop through each point after the first and draw lines to each
    for (let i = 1; i < points.length; i++) {
      pointField = getPointField(points[i].x, points[i].y);
      ctx.lineTo(pointField.x, pointField.y);
    }

    ctx.closePath();
    ctx.stroke();
  };
}
